module.exports = __webpack_public_path__ + "static/media/danger.43764c53.wav";